<template>
    <v-dialog v-model="controls.showDialog" style="z-index:1000" max-width="800" scollable :fullscreen="$vuetify.breakpoint.smAndDown" :persistent="controls.loading">
        <template v-slot:activator="{on}">
            <v-btn v-on="on" outlined tile small color="black">{{editing ? 'Edit Routes' : 'Create Route'}}</v-btn>
        </template>
            <v-card :loading="controls.loading" style="z-index:1001">
                <v-card-title>
                    {{editing ? 'Edit Routes' : 'Create Route'}}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="form" v-model="controls.validForm" @submit.prevent>
                        <v-autocomplete
                                label="Select Route to edit"
                                v-if="editing"
                                :items="routes"
                                item-text="name"
                                return-object
                                @change="form = $event"
                                filled
                        >
                        </v-autocomplete>
                        <v-text-field
                                v-model="form.name"
                                :rules="[formRules.required]"
                                label="Name the route"
                                :disabled="controls.loading"
                                filled
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.description"
                                :rules="[formRules.required]"
                                label="Description for this route"
                                :disabled="controls.loading"
                                filled
                        >
                        </v-text-field>
                        <v-divider></v-divider>
                        <i>Select days this route should be available</i>
                        <v-row justify="space-around">
                            <v-checkbox
                                    v-model="form.days.sunday"
                                    label="sunday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.monday"
                                    label="monday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.tuesday"
                                    label="tuesday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.wednesday"
                                    label="wednesday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.thursday"
                                    label="thursday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.friday"
                                    label="friday"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="form.days.saturday"
                                    label="saturday"
                            >
                            </v-checkbox>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="controls.showDialog = false" :disabled="controls.loading" text>close</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="editing ? update() : save()" :disabled="!controls.validForm || controls.loading" color="success">{{editing ? 'update' : 'submit'}}</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
    import firebase from 'firebase/app';
    import 'firebase/firestore';
    export default {
        name: "CreateRoute",
        data: () => ({
            controls:{
                showDialog: false,
                loading: false,
                validForm: true,
            },
            form:{
                name: null,
                description: null,
                days: {
                    sunday: false,
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                }
            },
            formRules:{
                required: v => !!v || "This field is required"
            },
            queried: {
                routes: []
            }
        }),
        props:{
            editing: {
              default: false,
              type: Boolean
            },
            routes: {
                required: false,
                type: Array,
            }
        },
        mounted(){

        },
        methods:{
            getRoutes(){
                this.$firestore
                    .collection('routes')
                    .get().then(routes => {
                        this.queried.routes = [];
                        routes.forEach(route => {
                            this.queried.routes.push({
                                id: route.id,
                                ...route.data()
                            })
                        })
                })
            },
            save(){

                this.$firestore
                    .collection('routes')
                    .doc()
                    .set(this.form, {merge:true})
                    .then(() => {
                        this.controls.loading = false;
                        this.$store.dispatch("showSuccess", "Saved Route!");
                        this.$refs.form.reset();
                        this.controls.showDialog = false;
                    }).catch((error) => {
                      console.log(error);
                      this.$store.dispatch("showError", error)
                })
            },
            update(){
                this.controls.loading = true;
                this.$firestore
                    .collection('routes')
                    .doc(this.form.id)
                    .update(this.form)
                    .then(() => {
                        this.controls.loading = false;
                        this.$store.dispatch("showSuccess", "Updated Route!");
                        this.$refs.form.reset();
                        this.getRoutes();
                        this.controls.showDialog = false;
                    }).catch((error) => {
                      console.log(error);
                      this.$store.dispatch("showError", error)
                })
            }
        }
    }
</script>

<style scoped>

</style>
